module.exports = __webpack_public_path__ + "static/media/layerTween.fc24b5ef.svg";